import styled from 'styled-components';
import { getTheme, pxToRem } from '~/modules';
import Typography from '../Typography';

const backgroundZ4 = getTheme('background.z4');

const spacingSm = getTheme('spacing.sm');
const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');
const themeRadiusCard = getTheme('themeRadius.card');

export const Row = styled.div`
  flex: 1;
  align-items: center;
  margin-right: ${spacingSm}px;
`;

export const RowMcc = styled.div`
  width: 16%;
  align-items: center;
  margin-right: ${spacingSm}px;
`;

export const Card = styled.div`
  align-items: center;
  width: 100%;
  min-height: ${pxToRem(110)};
  padding: 0 ${spacingLg}px;
  background: ${backgroundZ4};
  border-radius: ${themeRadiusCard}px;

  & + & {
    margin-top: ${spacingSm}px;
  }
`;

export const MCC = styled(Typography).attrs({ variant: 'md' })`
  font-weight: bold;
  flex: 1;
  margin-right: ${spacingMd}px;
  line-height: 120%;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const Description = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-right: ${spacingMd}px;
`;

export const WrapperToggle = styled.div`
  width: ${pxToRem(100)};
  justify-content: flex-end;
`;
